{
  "success": true,
  "moduleType": "cafeteria",
  "targetLevel": 2
}
